import {Timeline, VisuallyHidden} from '@primer/react'
import {SkeletonBox, SkeletonText} from '@primer/react/experimental'
import styles from './TimelinePanel.module.css'

type SkeletonRowRef = (el: Element | null) => void

export function TimelinePanelSkeleton({count = 7}: {count?: number}) {
  return (
    <div role="status" aria-live="polite" aria-busy>
      <VisuallyHidden>Loading timeline</VisuallyHidden>
      <Timeline clipSidebar="both" aria-hidden>
        <TimelinePanelSkeletonRows count={count} />
      </Timeline>
    </div>
  )
}

export function TimelinePanelSkeletonRows({
  count = 7,
  'aria-hidden': ariaHidden,
  firstRowRef,
}: {
  count?: number
  'aria-hidden'?: boolean
  firstRowRef?: SkeletonRowRef
}) {
  return Array.from({length: count}, (_, i) => (
    <TimelineEventSkeletonRow key={i} aria-hidden={ariaHidden} rowRef={i === 0 ? firstRowRef : undefined} />
  ))
}

function TimelineEventSkeletonRow({
  'aria-hidden': ariaHidden,
  rowRef,
}: {
  'aria-hidden'?: boolean
  rowRef?: SkeletonRowRef
}) {
  return (
    <Timeline.Item condensed aria-hidden={ariaHidden} ref={rowRef}>
      <Timeline.Badge>
        <SkeletonBox className={styles.skeletonBadge} />
      </Timeline.Badge>
      <Timeline.Body>
        <SkeletonText size="bodySmall" className={styles.skeletonActorText} />
      </Timeline.Body>
    </Timeline.Item>
  )
}
